<template>
  <div class="cart-page__header">
    <!--    <CheckboxComponent :checked="allChecked" @change="checkAll">Выбрать все</CheckboxComponent>-->
    <span class="cart-page__header-action" @click="updateCart">Очистить корзину</span>
  </div>
</template>

<script>
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";
import CLEAR_CART from "gql/mutations/CartDelete.graphql";
export default {
  name: "CartHeaderComponent",

  data() {
    return {
      check: false,
    };
  },

  methods: {
    updateCart() {
      if (this.$store.state.auth.cart.length) {
        if (confirm("Вы уверены?")) {
          this.$apollo.provider.defaultClient
            .mutate({
              mutation: CLEAR_CART,
              context: {
                headers: {
                  Authorization: "Bearer " + this.$store.state.apollo_token,
                },
              },
            })
            .then(() => {
              this.$store.dispatch("USER", {
                apollo: this.$apollo.provider,
              });
              this.$store.state.auth.activeCartItems = [];
            });
        }
      }
    },
    checkAll(event) {
      if (event) {
        this.$store.state.auth.activeCartItems = this.$store.state.auth.cart;
      } else {
        this.$store.state.auth.activeCartItems = [];
      }
    },
  },
  computed: {
    allChecked() {
      return this.$store.state.auth.activeCartItems.length
        ? this.$store.state.auth.activeCartItems.length === this.$store.state.auth.cart.length
        : false;
    },
  },
  components: {
    CheckboxComponent,
  },
};
</script>

<style lang="stylus">
.cart-page {

  &__header {
    padding 20px 30px
    border-radius 20px
    background var(--white)
    display flex
    justify-content space-between
    align-items center
    width 100%

    +below(1024px) {
      padding 16px 24px
    }

    .check {
      gap 25px
      font-weight: 400;
      font-size: 1.5em
      line-height: 28px;

      +below(1024px) {
        font-size 1em
        line-height 19px
      }
    }
  }

  &__header-action {
    color var(--red-2)
    font-weight: 400;
    font-size: 1rem;
    line-height: 19px;
    cursor pointer
    margin-left: auto
  }

}
</style>
